export default "__VITE_ASSET__DO9tD0Ak__"